import { SGeneralForms, SLocalTreeSelected, SSegmentedTabs } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { Button, Input, Radio, Select, TreeSelect, Spin } from 'antd'
import { getProductEnums, getProjectPage } from '@/services/product.ts'
import { useSetState } from 'ahooks'
import { replaceRule, trimStr } from '@/utils/data.ts'
import { getChildrenDicts } from '@/services'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import { cloneDeep } from 'lodash-es'
import _ from 'lodash'

type IProps = {
  fn: () => void
  readOnly?: boolean
  companyList: any[]
  setSubmitLoading: (v: boolean) => void
  spaceList: any[]
  dataSource: any[]
  record: any
}

export const AddOrEditProject = forwardRef((props: IProps, ref) => {
  const { companyList = [], dataSource = [], record } = props
  const formRef = useRef()
  const [state, setState] = useSetState<any>({
    chooseLimit: [],
    copyDisabled: false,
    loading: false,
  })
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const dealTree = (data, res = []) => {
    data.forEach(item => {
      if (item.busType === 'PRD_CATE') {
        res.push(item)
        if (item.children?.length) {
          item.children = dealTree(item.children)
        }
      }
    })
    return res
  }

  const spaceList = useMemo((): any[] => {
    if (record.spaceTag && props.spaceList) {
      return (
        props.spaceList?.map(item => {
          const item_ = { ...item }
          if (item.priKey === record.spaceTag) {
            item_.disabled = false
          }
          return item_
        }) || []
      )
    }
    console.log(props.spaceList, '空间=======》')
    return props.spaceList || []
  }, [props.spaceList, record])

  const tree = useMemo(() => {
    return dealTree(cloneDeep(dataSource))
  }, [dataSource])

  useEffect(() => {
    onFormRef()?.resetFields()
    setRuleModal({ value: '' })
    console.log(record, 'PROJECT')
    onFormRef()?.setFieldsValue({
      ...record,
      parentId: record.parentId == 0 ? null : record.parentId,
      shops: record.shops,
    })
    shopsControl(record.shops)
    if (!record.subChooseType && state.chooseLimit.length) {
      onFormRef()?.setFieldValue('subChooseType', state.chooseLimit[0]?.value)
    }
    const rule = JSON.parse(record.subFilterRule || null)?.rule || ''
    setRuleModal({ value: rule })
  }, [record, state.chooseLimit])

  const getOptions = async (): Promise<{ [key: string]: any }> => {
    setState({ loading: true })
    try {
      const chooseLimit = await getProductEnums(
        'com.shj.saas.plus.product.enums.GenChooseConfineEnum'
      )
      setState({
        chooseLimit: chooseLimit.map(item => ({ label: item.description, value: item.key })),
        loading: false,
      })
      return Promise.resolve({ ...props.options })
    } catch (e) {
      setState({ loading: false })
    }
  }

  const getShopArr = (codeArr: string[] = []) => {
    return optionList?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setSubmitLoading?.(true)
          const shopList = values.shops ? getShopArr(values.shops) : []
          resolve({
            ...values,
            id: record.id,
            parentId: values.parentId,
            oldParentId: record.parentId || '0',
            level: record.level || 0,
            children: record.children,
            busType: 'PRD_PROJECT',
            busTypeName: '项目',
            busId: values.busId,
            shopList: shopList,
            shops: values.shops,
            subFilterRule: JSON.stringify({ rule: ruleModal.value }),
          })
        })
    })
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  return (
    <>
      <Spin spinning={state.loading}>
        <SGeneralForms
          isDetail={props.readOnly}
          ref={formRef}
          isHideGobackBtn={true}
          httpOptionsFn={getOptions}
          titleMode={'edit'}
          initialValues={{ isMust: true, isCopy: true, isShowOrder: true, isShowSum: true }}
          layout="vertical"
          configs={[
            {
              title: '基础信息',
              formItem: [
                { name: 'id', hidden: true },
                {
                  name: 'parentId',
                  label: '所属分类',
                  spanCol: 24,
                  children: (
                    <TreeSelect
                      treeData={tree}
                      placeholder={'请选择上级分类'}
                      fieldNames={{ label: 'name', value: 'id' }}
                      treeTitleRender={node => node?.dtlName}
                    />
                  ),
                  isHideItem: props.page === 'sub',
                },
                {
                  name: 'busId',
                  label: '项目',
                  required: true,
                  rules: [{ required: true, message: '项目不能为空' }],
                  spanCol: 24,
                  children: (
                    <DebounceSearchSelect
                      label={'项目'}
                      query={{ id: record.busId }}
                      fetchOptions={getProjectPage}
                      nameKey={'itemNameLike'}
                      fieldNames={{ label: 'itemName' }}
                      onChange={(v, o) => o && onFormRef()?.setFieldValue('dtlName', o.label)}
                    />
                  ),
                },
                {
                  name: 'dtlName',
                  label: '显示名称',
                  required: true,
                  rules: [{ required: true, message: '显示名称不能为空' }],
                  spanCol: 24,
                  comConfig: {
                    showCount: true,
                    maxLength: 15,
                    onChange: e => onFormRef()?.setFieldValue('dtlName', trimStr(e.target.value)),
                  },
                },
              ],
            },
            {
              title: '打包配置',
              formItem: [
                {
                  name: 'isMust',
                  label: '是否必选',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  name: 'subChooseType',
                  label: '子集选择限制',
                  spanCol: 24,
                  children: <Radio.Group options={state.chooseLimit} />,
                },
                {
                  name: 'subChooseValue',
                  label: '多选个数上限',
                  isDeps: true,
                  deps: form => form.getFieldValue('subChooseType') === 'MORE_CHOOSE',
                  spanCol: 24,
                  required: true,
                  rules: [{ required: true, message: '多选个数上限不能为空' }],
                  type: 'inputNumber',
                  comConfig: { min: 2, precision: 0, max: 9999 },
                },
                {
                  label: '子集产品过滤',
                  spanCol: 24,
                  children: (
                    <div>
                      <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                      {ruleModal?.value && (
                        <Input.TextArea
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          disabled
                          style={{ marginTop: 6 }}
                          value={replaceRule(ruleModal.value)}
                        />
                      )}
                    </div>
                  ),
                },
                {
                  name: 'spaceTag',
                  label: '空间标签',
                  children: (
                    <Select
                      placeholder={'请选择空间标签'}
                      allowClear
                      showSearch
                      optionFilterProp={'children'}
                      onChange={v => {
                        setState({ copyDisabled: !!v })
                        if (v) {
                          onFormRef()?.setFieldValue('isCopy', true)
                        }
                      }}
                    >
                      {spaceList?.map(item => (
                        <Select.Option disabled={['kj03', 'kj04', 'kj05', 'kj08', 'kj09', 'kj10'].includes(item.priKey) ? item.disabled : false} value={item.priKey}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  ),
                  spanCol: 24,
                },
                {
                  name: 'isCopy',
                  label: '是否允许复制',
                  comConfig: {
                    // disabled: state.copyDisabled,
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                  spanCol: 24,
                  type: 'switch',
                },
              ],
            },
            {
              title: '显示配置',
              formItem: [
                {
                  name: 'isShowOrder',
                  label: '下单时是否显示',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  name: 'isShowSum',
                  label: '汇总金额是否显示',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
              ],
            },
            {
              title: '适用渠道',
              formItem: [
                {
                  name: 'shops',
                  label: '适用门店',
                  spanCol: 24,
                  children: (
                    <Select
                      optionFilterProp={'name'}
                      placeholder={'请选择适用门店'}
                      mode={'multiple'}
                      fieldNames={{ label: 'name', value: 'id' }}
                      onChange={(value, option) => {
                        shopsControl(value)
                      }}
                      options={optionList}
                    />
                  ),
                },
              ],
            },
          ]}
        />
      </Spin>
      <RulesModal
        modalProps={{ ...ruleModal }}
        type={'productFilterRule'}
        onCancel={() => setRuleModal({ open: false })}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </>
  )
})
